<template>
    <div class="jadwal-rilis">
       <div class="row">
            <div class="col-12">
                <h5 class="title-jadwal-rilis" @mouseover="accebility('jadwal-rilis')" v-bind:style="jadwalrilisAccebility(isAccebility)"><img class="image-title" v-bind:src="require('@/assets/icon/icon-title.png')" />JADWAL RILIS</h5>
            </div>
            <div v-bind:class="columnStyle.columnRow+ ' cards-jadwal-rilis'">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 title">Dataset</div>
                            <div class="col-12 tahun">Tahun {{tahunData}}</div>
                            <EasyDataTable :headers="headersTableopendata" :items="itemsTableopendata" hide-footer>
                                <template #empty-message>
                                    <p>Tidak ada data</p>
                                </template>
                            </EasyDataTable>
                            <a class="col-12 selengkapnya" :href="selengkapnya('jadwal-rilis-dataset')">Selengkapnya...</a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-bind:class="columnStyle.columnRow+ ' cards-jadwal-rilis'">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 title">Artikel dan Produk</div>
                            <div class="col-12 tahun">Tahun {{tahunData}}</div>
                            <EasyDataTable :headers="headersTablestatistik" :items="itemsTablestatistik" hide-footer>
                                <template #empty-message>
                                    <p>Tidak ada data</p>
                                </template>
                            </EasyDataTable>
                            <a class="col-12 selengkapnya" :href="selengkapnya('jadwal-rilis-statistik-sektoral')">Selengkapnya...</a>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
 </template>
 <script>
    import axios from "axios";
    export default {
        name: "JadwalRilisComponents",
        components: {},
        data() {
            return {
                baseUrl:this.$store.state.baseUrl,
                baseApi:this.$store.state.apiUrl,
                dataOpendata: [],
                dataStatistik: [],
                headersTableopendata: [],
                itemsTableopendata: [],
                headersTablestatistik: [],
                itemsTablestatistik: [],
                filterStatus:'all',
                tahunData:'0',
                currentDate:'0',
                columnStyle: [],
                windowWidth: window.innerWidth,
                isAccebility:this.$store.state.isAccebility
            };
        },
        mounted() {
            
            this.$nextTick(() => {
                window.addEventListener("resize", this.onResize);
            });
            
            if (this.windowWidth <= "430") {
                this.columnStyle = {
                    columnRow: "col-12",
                };
            } else if(this.windowWidth > "430" && this.windowWidth <= "820") {
                this.columnStyle = {
                    columnRow: "col-12",
                };
            } else {
                this.columnStyle = {
                    columnRow: "col-6",
                }; 
            }

            let dKalenderdata = new Date()
            let dateKalenderData = ("0" + (dKalenderdata.getDay())).slice(-2)
            let monthKalenderData = ("0" + (dKalenderdata.getMonth()+1)).slice(-2)
            let yearKalenderData = dKalenderdata.getFullYear()
            let tanggalRilisKalendarData = yearKalenderData+monthKalenderData
            this.tahunData = yearKalenderData
            this.currentDate = yearKalenderData+"-"+monthKalenderData+"-"+dateKalenderData

            let paramsKalenderdata = {
                type: 'jadwal-rilis',
                category: 'agenda',
                tanggal_rilis: tanggalRilisKalendarData,
                status: this.filterStatus
            }

            axios.post(`${this.baseApi}/api/v2/satudata/jadwal-rilis-kalender-data`, paramsKalenderdata).then(res=>{
                let getDats = res.data.data
                let datas = []

                let lengthArr = 0
                if(getDats.length<5){
                    lengthArr = getDats.length
                } else {
                    lengthArr = 5
                }

                for(var i = 0; i<lengthArr; i++){
                    let rawJadwalrilis = getDats[i].tanggal_rilis.substring(0,4) + "-" + getDats[i].tanggal_rilis.substring(4)+ "-01"
                    let getDates = new Date(rawJadwalrilis)
                    let month = getDates.toLocaleString("id-ID", { month: 'long' });
                    let year = getDates.toLocaleString("id-ID", { year: "numeric" });
                    let jadwalRilis = month+' '+year

                    var dats = {
                        title: getDats[i].deskripsi,
                        time: jadwalRilis,
                        page_url: getDats[i].page_url
                    }
                    datas.push(dats)
                }
                this.dataOpendata = datas
                this.headersTableopendata = [
                    { text: "Judul", value: "title" },
                    { text: "Jadwal Rilis", value: "time", width: 100 }
                ]
                this.itemsTableopendata = datas
            })

            let paramsStatisitksektoral = {
                type: 'jadwal-rilis',
                category: 'calendar',
                tanggal_rilis: tanggalRilisKalendarData
            }

            axios.post(`${this.baseApi}/api/v2/satudata/jadwal-rilis-statistik-sektoral`, paramsStatisitksektoral).then(res=>{
                let datas = []
                let getDats = res.data.data

                let lengthArr = 0
                if(getDats.length<5){
                    lengthArr = getDats.length
                } else {
                    lengthArr = 5
                }

                for(var i = 0; i<lengthArr; i++){
                    let getDates = new Date(getDats[i].date_created);
                    // let day = getDates.toLocaleString("id-ID", { day: "numeric" });
                    let month = getDates.toLocaleString("id-ID", { month: "long" });
                    let year = getDates.toLocaleString("id-ID", { year: "numeric" });
                    // let jadwalRilis = day+" "+month + " " + year;
                    let jadwalRilis = month + " " + year;

                    var dats = {
                        title: getDats[i].title,
                        full_title: getDats[i].full_title,
                        time: jadwalRilis,
                        page_url: getDats[i].title
                    }
                    datas.push(dats)
                }
                this.dataStatistik = datas
                this.headersTablestatistik = [
                    { text: "Judul", value: "title" },
                    { text: "Jadwal Rilis", value: "time", width: 100  }
                ]
                this.itemsTablestatistik = datas
            })

            
        },
        methods: {
            limitTitle(string = "", limit = 0) {
                if (string) {
                    let next = "";
                    if (string.length > limit) {
                        next = " ...";
                    }
                    return string.substring(0, limit) + next;
                }
            },
            onResize() {
                this.windowWidth = window.innerWidth;
            },
            jadwalrilisAccebility(isAccebility){
                if(isAccebility.modeMalam){
                    return{
                        color: 'white'
                    }
                } else {
                    return{
                        color: '#052158'
                    }
                }
            },
            accebility(voice){
                if(this.isAccebility.modeSuara){
                let msg = new SpeechSynthesisUtterance();
                let voices = window.speechSynthesis.getVoices()
                msg.voice = voices[160];
                msg.text = voice;
                msg.volume = 10;
                msg.rate = 1;
                msg.pitch = 1;
                window.speechSynthesis.cancel();
                window.speechSynthesis.speak(msg);
                }
            },
            eventChngescreen(e) {
                this.windowWidth = e.currentTarget.screen.availWidth
                if (this.windowWidth <= "430") {
                    this.columnStyle = {
                        columnRow: "col-12",
                    };
                } else if(this.windowWidth > "430" && this.windowWidth <= "820") {
                    this.columnStyle = {
                        columnRow: "col-12",
                    };
                } else {
                    this.columnStyle = {
                        columnRow: "col-6",
                    }; 
                }
            },
            selengkapnya(kategori){
                return this.baseUrl + "/kalender?kategori="+kategori
            },
            toDate(items){
                let dates = new Date(items)
                let month = dates.toLocaleString("id-ID",{month:"long"})                
                let date = ("0" + (dates.getDay() + 1)).slice(-2)
                return date+' '+month+' '+dates.getFullYear()
            }
        },
        created() {
            window.addEventListener("resize", this.eventChngescreen);
        },
        beforeUnmount() {
            window.removeEventListener("resize", this.eventChngescreen);
        }
    };
 </script>